import { SITE_URL } from "../../../data/site"

export type Crumb = {
  name: string
  to: string
}

export const buildBreadcrumbList = (crumbs: Crumb[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: `${SITE_URL}${crumb.to}`,
  })),
})
